module.exports = __webpack_public_path__ + "static/media/20190401_173050.72604dc6.jpg";